import Evee from 'evee';
import EventBus from './EventBus';

export default class AndroidWebPlayer extends Evee {
    constructor(androidAPI) {
        super();

        this.source = null;
        this.androidAPI = androidAPI;

        console.log('AndroidWebPlayer: found API', this.androidAPI);

        this.canPlayFlac = true;

        this.androidAPI.on('playback.end', () => {
            console.log('AWP EVENT: playback.end')
            this.emit('playback.end', {});
        });
        this.androidAPI.on('playback.pause', () => {
            console.log('AWP EVENT: playback.pause')
            this.emit('playback.pause', {});
        });
        this.androidAPI.on('playback.start', () => {
            console.log('AWP EVENT: playback.start')
            this.emit('playback.start', {});
        });
        this.androidAPI.on('playback.loading', (e) => {
            this.emit('playback.loading', e.data);
        });
        this.androidAPI.on('playback.position', (e) => {
            this.emit('playback.position', e.data);
        });
        this.androidAPI.on('controls.next', (e) => {
            EventBus.emit('controls.next', {});
        });
        this.androidAPI.on('controls.prev', (e) => {
            EventBus.emit('controls.previous', {});
        });
    }

    changeSource(source, track) {
        this.androidAPI.playTrack(source, track);
    }
    
    sendQueue(items) {
        this.androidAPI.sendQueue(items);
    }

    prepareNext(source) {
        this.androidAPI.prepareNext(source);
    }

    play() {
        this.androidAPI.resume();
    }

    pause() {
        this.androidAPI.pause();
    }

    stop() {
        this.androidAPI.stop();
    }

    setVolume(amount) {
        this.androidAPI.setVolume(amount);
    }

    seek(time) {
        this.androidAPI.seek(time);
    }

    seekPercent(percent) {
        this.androidAPI.seekPercent(percent);
    }

    getPosition() {
        return 0;
    }

}



// WEBPACK FOOTER //
// ./src/AndroidWebPlayer.js